@if (!editMode) {
  <div>
    @if (imageSrc !== undefined && !showLargeImage) {
      <img [src]="imageSrc" class="show-image" (click)="showOriginal()" />
    }
    @if (imageSrc === undefined) {
      <div>No Image</div>
    }
  </div>
} @else {
  <mat-form-field [formGroup]="formGroup" class="example-full-width">
    <div class="info">
      <label
        class="uploader"
        ondragover="return false;"
        [ngClass]="{ loaded: loadedImage }"
        [style.borderColor]="dragging ? activeColor : baseColor"
        (dragenter)="handleDragEnter()"
        (dragleave)="handleDragLeave()"
        (drop)="handleDrop($event)">
        @if (imageSrc) {
          <img [src]="imageSrc" (load)="handleImageLoad()" [class.loaded]="loadedImage" />
        }
        <input readonly formControlName="{{ fieldConfig.name }}" matInput />
        @if (!imageSrc) {
          <button type="button" mat-button (click)="imgFileInput.click()" class="upload-button">Add image</button>
        }
        @if (imageSrc) {
          <button type="button" mat-mini-fab color="primary" (click)="imgFileInput.click()" class="edit-button">
            <mat-icon>edit</mat-icon>
          </button>
        }
        <input #imgFileInput type="file" name="file" accept="image/*" (change)="handleInputChange($event)" />
      </label>
    </div>
  </mat-form-field>
}

@if (showLargeImage) {
  <div id="myModal" class="modal">
    <!-- The Close Button -->
    <span class="close" (click)="onClose()">&times;</span>
    <!-- Modal Content (The Image) -->
    <img class="modal-content" id="img01" [src]="imageSrc" />
    <!-- Modal Caption (Image Text) -->
    <div id="caption"></div>
  </div>
}

<!--
<div *ngIf="showLargeImage" class="internal-wrapper-1">
  <div class="internal-wrapper-2">
    <div class="dummyheader">Image
      <button type="button" class="close" (click)="onClose()" aria-hidden="true">×</button>
    </div>
    <div class="html-preview-scroll">
      <img [src]="imageSrc">
    </div>
  </div>
</div>
-->
